import React, { useMemo } from 'react';

import { groupBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import ListObjectFilter from 'common-ui/lists/listObjectFilter';
import { PortfolioListing } from 'core/lib';
import { OBJECT_TYPES } from 'core/lib/constants';

type PortfoliosByResponsibleProps = {
  data?: PortfolioListing[];
};

const PortfoliosByResponsible = ({ data }: PortfoliosByResponsibleProps) => {
  const { t } = useTranslation();

  const dataByResponsible = useMemo(
    () => groupBy(data, (d) => d.responsible?.name ?? t('global:results.notSpecified')),
    [data, t]
  );

  return (
    <ListObjectFilter<PortfolioListing>
      placeholder={t('portfolio:placeholders.searchResponsible')}
      data={dataByResponsible}
      title={t('portfolio:dashboards.titles.responsible')}
      objectType={OBJECT_TYPES.PORTFOLIO}
    />
  );
};

export default PortfoliosByResponsible;
